<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            type="year"
            label="감사년도"
            default="today"
            name="selfInspectionYear"
            v-model="searchParam.selfInspectionYear"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept 
            :editable="editable" 
            :disabled="disabled"
            type="search" 
            :isFirstValue="false"
            label="대상부서" 
            name="deptCd" 
            v-model="searchParam.deptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="SELF_INSPECTION_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="selfInspectionTypeCd"
            label="자체감사종류"
            v-model="searchParam.selfInspectionTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="자체감사 목록"
      tableId="accidentSeq"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn label="LBLREG" v-if="editable" icon="add" @btnClicked="linkClick" />
            <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "compliance",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            sortable: true,
          },
          {
            name: "selfInspectionYear",
            field: "selfInspectionYear",
            label: "감사년도",
            align: "center",
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: "selfInspectionTitle",
            field: "selfInspectionTitle",
            label: "감사명",
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "selfInspectionTypeName",
            field: "selfInspectionTypeName",
            label: "감사종류",
            align: "center",
            sortable: true,
          },
          {
            name: "selfInspectionStartDt",
            field: "selfInspectionStartDt",
            label: "감사시작일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "selfInspectionEndDt",
            field: "selfInspectionEndDt",
            label: "감사종료일",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "deptNames",
            field: "deptNames",
            label: "대상부서",
            align: "left",
            style: 'width: 250px',
            sortable: true,
          },
          {
            name: "selfInspectionStatusName",
            field: "selfInspectionStatusName",
            label: "LBLSTEPPROGRESS",
            align: "center",
            style: 'width: 120px',
            sortable: true,
          },
          {
            name: "approvalStatusName",
            field: "approvalStatusName",
            label: "결재상태",
            style: 'width: 120px',
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        selfInspectionYear: null,
        selfInspectionTypeCd: null,
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sop.pca.result.info.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = "자체감사 상세"; // 자체감사 상세
      this.popupOptions.param = {
        selfInspectionResultId: (row ? row.selfInspectionResultId : ''),
        selfInspectionStatusCd: (row ? row.selfInspectionStatusCd : ''),
        sysRevision: (row ? row.sysRevision : ''),
      };
      this.popupOptions.target = () => import(`${"./complianceDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
